import React, { useState } from 'react'
import { CheckIcon } from '@heroicons/react/outline'
import GroceriesService from "../../../services/GroceriesService";
import ClientService from '../../../services/ClientService';

const MeasurementForm = ({ measurementData, clientId, modalTitle, setIsOpen, setMeasurementsData, deleteMeasurement, addMeasurement }) => {

    const {
        height: heightData,
        size: sizeData,
        bodyMass: bodyMassData,
        fatPercentage: fatPercentageData,
        waterPercentage: waterPercentageData,
        visceralFat: visceralFatData,
        muscleMass: muscleMassData,
        bodyFitnessIndex: bodyFitnessIndexData,
        boneMass: boneMassData,
        baseMetabolism: baseMetabolismData,
        metabolicAge: metabolicAgeData,
        bmi: bmiData,
        upperArm: upperArmData,
        chest: chestData,
        waist: waistData,
        hips: hipsData,
        thighs: thighsData,
        stomach: stomachData,
        measurementDate: measurementDateData,
    } = measurementData;

    const [height, setHeight] = useState(heightData || '');
    const [size, setSize] = useState(sizeData || '');
    const [bodyMass, setBodyMass] = useState(bodyMassData || '');
    const [fatPercentage, setFatPercentage] = useState(fatPercentageData || '');
    const [waterPercentage, setWaterPercentage] = useState(waterPercentageData || '');
    const [visceralFat, setVisceralFat] = useState(visceralFatData || '');
    const [muscleMass, setMuscleMass] = useState(muscleMassData || '');
    const [bodyFitnessIndex, setBodyFitnessIndex] = useState(bodyFitnessIndexData || '');
    const [boneMass, setBoneMass] = useState(boneMassData || '');
    const [baseMetabolism, setBaseMetabolism] = useState(baseMetabolismData || '');
    const [metabolicAge, setMetabolicAge] = useState(metabolicAgeData || '');
    const [bmi, setBmi] = useState(bmiData || '');
    const [upperArm, setUpperArm] = useState(upperArmData || '');
    const [chest, setChest] = useState(chestData || '');
    const [waist, setWaist] = useState(waistData || '');
    const [hips, setHips] = useState(hipsData || '');
    const [thighs, setThighs] = useState(thighsData || '');
    const [stomach, setStomach] = useState(stomachData || '');
    const [measurementDate, setMeasurementDate] = useState(measurementDateData || '');

    const formValues = {
        height,
        size,
        bodyMass,
        fatPercentage,
        waterPercentage,
        visceralFat,
        muscleMass,
        bodyFitnessIndex,
        boneMass,
        baseMetabolism,
        metabolicAge,
        bmi,
        upperArm,
        chest,
        waist,
        hips,
        thighs,
        stomach,
        measurementDate,
    };

    const inputsData = [
        {
            label: "Visina",
            stateData: height,
            setStateData: setHeight,
        },
        {
            label: "Mere",
            stateData: size,
            setStateData: setSize,
        },
        {
            label: "Telesna Masa",
            stateData: bodyMass,
            setStateData: setBodyMass,
        },
        {
            label: "% masti",
            stateData: fatPercentage,
            setStateData: setFatPercentage,
        },
        {
            label: "% vode",
            stateData: waterPercentage,
            setStateData: setWaterPercentage,
        },
        {
            label: "% visceralnih masti",
            stateData: visceralFat,
            setStateData: setVisceralFat,
        },
        {
            label: "Mišićna masa",
            stateData: muscleMass,
            setStateData: setMuscleMass,
        },
        {
            label: "Ocena fizičke spremnosti",
            stateData: bodyFitnessIndex,
            setStateData: setBodyFitnessIndex,
        },
        {
            label: "Masa kostiju",
            stateData: boneMass,
            setStateData: setBoneMass,
        },
        {
            label: "Bazalni metabolizam",
            stateData: baseMetabolism,
            setStateData: setBaseMetabolism,
        },
        {
            label: "Metabolicka starost",
            stateData: metabolicAge,
            setStateData: setMetabolicAge,
        },
        {
            label: "BMI",
            stateData: bmi,
            setStateData: setBmi,
        },
        {
            label: "Nadlaktica",
            stateData: upperArm,
            setStateData: setUpperArm,
        },
        {
            label: "Grudi",
            stateData: chest,
            setStateData: setChest,
        },
        {
            label: "Struk",
            stateData: waist,
            setStateData: setWaist,
        },
        {
            label: "Kukovi",
            stateData: hips,
            setStateData: setHips,
        },
        {
            label: "Butine",
            stateData: thighs,
            setStateData: setThighs,
        },
        {
            label: "Stomak",
            stateData: stomach,
            setStateData: setStomach,
        },
        {
            label: "Datum merenja",
            stateData: measurementDate,
            setStateData: setMeasurementDate,
        },
    ]

    const isNullOrWhitespace = value => {
        if (value instanceof String) {
            if (!value || value.trim() === '') {
                return true;
            }
        }

        return false;
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        // let tempForm = { ...formValues, clientId }
        // ClientService.addMeasurement(clientId, tempForm).then((response) => {
        //     setMeasurementsData([...response.data])
        //     setIsOpen(false);
        // });

        addMeasurement(measurementData, formValues, clientId);
        setIsOpen(false);


    }

    return (
        <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-xs '>{modalTitle}</h3>
            <form className="flex flex-wrap w-full px-2">

                {inputsData.map(({ stateData, setStateData, label, type }, i) => (
                    <div className="mt-3 w-full md:w-6/12 2xl:w-4/12 px-2" key={i}>
                        {
                            type === 'textarea' &&
                            <div className="input-group" >
                                <label htmlFor={i} className="font-xs text-xs text-gray-500">{label}</label>
                                <textarea type="text" id={i} value={stateData} onChange={(e) => setStateData(e.target.value)} className="input-field" ></textarea>
                            </div>
                        }
                        {
                            type === 'checkbox' &&

                            <div className="input-group checkbox">
                                <input type="checkbox" id={i} value={stateData} onChange={(e) => setStateData(!stateData)} className="input-field" />
                                <label htmlFor={i} className="font-xs text-xs text-gray-500"><span className='check'><CheckIcon /></span>{label}</label>
                            </div>
                        }
                        {
                            type === 'label' &&
                            <div className="input-group">
                                <label htmlFor={i} className="font-xs text-xs text-gray-500">{label}</label>
                                <input type="text" id={i} value={stateData} className="input-field" />
                            </div>
                        }
                        {
                            type !== 'checkbox' && type !== 'textarea' && type !== 'label' &&
                            <div className="input-group">
                                <label htmlFor={i} className="font-xs text-xs text-gray-500">{label}</label>
                                <input type="text" id={i} value={stateData} onChange={(e) => setStateData(e.target.value)} className="input-field" />
                            </div>
                        }

                    </div>
                )
                )}
                <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>
                <div className="mt-5 w-full md:w-6/12 2xl:w-4/12 px-4">
                    <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-3" onClick={e => handleFormSubmit(e)}>
                        Sačuvaj
                    </button>
                </div>
                <div className="mt-5 w-full md:w-6/12 2xl:w-4/12 px-4">
                    <button type="submit" className="button without-icon bg-red-500 mx-auto mt-3" onClick={e => deleteMeasurement(clientId, measurementData.id)}>
                        Obriši
                    </button>
                </div>
            </form>
        </>
    )
}

export default MeasurementForm;
